<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />
            <br />
            {{ creditor.creditor_name }}
            <br />
            <template v-if="creditor.address">
                {{ creditor.address }}
            </template>
            <template v-else>
                {{ creditor.address_line }}<br /> {{ creditor.city }}, {{ creditor.state }} {{ creditor.zipcode }}
            </template>
            <br />
            <br />
            Date: {{ date }}
        </p>
        <p>
            RE: Account # {{ lodash.join(lodash.map(accounts, 'account_number'), ', ') }}
        </p>
        <p>
            To Whom It May Concern:
        </p>
        <p class="letter-content">
            On [insert date], I wrote to you and requested information about an account you are reporting on my credit report but you responded with only portions of the information requested. I then sent another letter to you on [insert date] advising that if you failed to respond with sufficient verification and/or comply with the law, then you would be subject to fines and damages, per the FCRA. I’ve received your letter dated [insert date] but you have still failed to comply.
            <br />
            <br />
            Your company has not sent me:
        </p>
        <ul>
            <li class="letter-content">
                The contract/agreement I signed legally binding me to this alleged debt
                <br>
            </li>
            <li class="letter-content">
                The information you used for fraud prevention and to verify my identity as the responsible person qualified to establish this account
                <br>
            </li>
            <li class="letter-content">
                The steps you took to verify my eligibility to establish this account (ie, employment verification, residence verification, etc.)
                <br>
            </li>
            <li class="letter-content">
                Verification of accurate billing (ie, every single itemized statement, payment, credit, interest added, disputed charges, etc.) from the time this alleged account was first established
                <br>
            </li>
            <li class="letter-content">
                A notarized statement on your letterhead which will attest to your compliance to the FCBA generally and to my account specifically throughout the period you claim I was a customer
                <br>
            </li>
            <li class="letter-content">
                A detailed and itemized statement of ALL activity to this account, including the contract I must have allegedly signed to bind me to this debt.
                <br>
            </li>
            <li class="letter-content">
                The photo identification I must have provided at the time of starting services with you in order for you to assure that this was not an attempt of someone else to commit a fraud against me (you do take these precautions correct?).
                <br>
            </li>
            <li class="letter-content">
                A full file disclosure.
                <br>
            </li>
            <li class="letter-content">
                An itemized statement breaking down the balance you claim I owe.
                <br>
            </li>
        </ul>
        <p class="letter-content">
            Please note, for the record, that this is my final attempt to reach a resolution directly through your company to resolve this issue. However, I am no longer merely requesting verification of this alleged debt. At this point, I am formally demanding that within the next 15 days, you remove this unverifiable account from any and all credit bureau reports in which you are reporting to and that you send me notification of your intent to do so.
        </p>
        <p class="letter-content">
            Should I not hear from you, again, within the next 15 days, and you are still reporting this account at that time, then the next communication you receive from me will include copies of formal complaints made to the Better Business Bureau, the State Attorney General, the Consumer Financial Protection Bureau, and the Federal Trade Commission – not to mention my legal counsel and the local media that I plan to reach out to in order to expose your unlawful business practices.
        </p>
        <p class="letter-content">
            I would much rather resolve this issue both swiftly and amicably without the involvement of anyone else. Therefore, your response by [insert date 2 weeks from now] would be greatly appreciated!
        </p>
        <p>
            Thank you for your time and attention to this matter.
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    import lodash from 'lodash'
    export default {
        props: {
            accounts: {
                type: [Array, Object]
            },
            creditor: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                lodash: lodash
            };
        }
    };
</script>